import Spinner from '@/presentation/components/spinner';
import Table from '@/presentation/components/table';
import { useEffect, useMemo, useState } from 'react';
import UsersLoggedFilter from './components/UsersLoggedFilter';
import { columns } from './env/columns';
import useUsersLogged from './hooks/use-users-logged';
import { exportUsersToExcel } from './utils/exportUsersToExcel';

const ReportUsersLoggedPage = () => {
  const { isLoading, data, fetchData } = useUsersLogged();
  const [filters, setFilters] = useState({
    document: '',
    name: '',
    lastname: '',
    email: '',
  });

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const filteredData = useMemo(() => {
    return data.filter((user) => {
      return (
        (!filters.document ||
          user.document
            ?.toLowerCase()
            .includes(filters.document.toLowerCase())) &&
        (!filters.name ||
          user.name?.toLowerCase().includes(filters.name.toLowerCase())) &&
        (!filters.lastname ||
          user.lastname
            ?.toLowerCase()
            .includes(filters.lastname.toLowerCase())) &&
        (!filters.email ||
          user.email?.toLowerCase().includes(filters.email.toLowerCase()))
      );
    });
  }, [data, filters]);

  return (
    <div className="flex flex-col gap-4 p-4">
      <h1 className="text-3xl font-bold">Usuarios que han ingresado</h1>
      
      {/* Tarjeta con el total de usuarios */}
      <div className="bg-white shadow-md rounded-lg p-6 border-l-4 border-primary">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-gray-600 text-sm font-medium">Total de usuarios que han ingresado</p>
            <p className="text-4xl font-bold text-gray-800 mt-2">
              {isLoading ? '...' : filteredData.length}
            </p>
          </div>
          <div className="bg-red-100 p-4 rounded-full">
            <svg className="w-10 h-10 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
          </div>
        </div>
      </div>

      <UsersLoggedFilter onFilter={setFilters} />
      <button
        className="self-end px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 mb-2"
        onClick={() => exportUsersToExcel(filteredData)}
        disabled={filteredData.length === 0}
      >
        Exportar a Excel
      </button>
      {isLoading ? (
        <div className="flex justify-center items-center h-full">
          <Spinner />
        </div>
      ) : (
        <Table columns={columns} data={filteredData} />
      )}
    </div>
  );
};

export default ReportUsersLoggedPage;
